import React, { useEffect } from "react";
import { Select, SelectProps } from "@mantine/core";

const PROGRESS_STYLE_OPTIONS = [
  {
    value: "none",
    label: "Disabled",
    disabled: false,
  },
  {
    value: "bar",
    label: "Bar",
    disabled: false,
  },
  {
    value: "dots",
    label: "Dots",
    disabled: false,
  },
  {
    value: "minimal",
    label: "Minimal",
    disabled: false,
  },
] as const;

export type ProgressStyleValue = "none" | "bar" | "dots" | "minimal";

export interface ProgressStyleSelectorProps
  extends Omit<SelectProps, "data" | "value" | "onChange"> {
  /** Current status value (100 for enabled, 0 for disabled) */
  value: string | null | undefined;

  /** Callback when status changes */
  onChange: (value: string | null) => void;
}

export const ProgressStyleSelector: React.FC<ProgressStyleSelectorProps> = ({
  value,
  onChange,
  placeholder = "Select timer mode",
  required,
  ...selectProps
}) => {
  // Prepare select data with optional descriptions
  const selectData = PROGRESS_STYLE_OPTIONS.map((option) => {
    let label: string = option.label;

    return {
      value: option.value,
      label,
      disabled: option.disabled,
    };
  });

  // Auto-select first display type if required and no value is set
  useEffect(() => {
    if (required && value == null && onChange) {
      const firstOption = PROGRESS_STYLE_OPTIONS[0];
      if (firstOption && !firstOption.disabled) {
        onChange(firstOption.value);
      }
    }
  }, [required, value, onChange]);

  // Handle change and convert back to number
  const handleChange = (stringValue: string | null) => {
    onChange(stringValue);
  };

  return (
    <Select
      {...selectProps}
      data={selectData}
      value={value}
      onChange={handleChange}
      placeholder={placeholder}
      clearable={false}
      allowDeselect={false}
      required
      size="md"
    />
  );
};

// Export status options for use in other components
export { PROGRESS_STYLE_OPTIONS };
